import { render, staticRenderFns } from "./StatisticsLicenseDetails.vue?vue&type=template&id=2523a7d3&scoped=true"
import script from "./StatisticsLicenseDetails.vue?vue&type=script&lang=ts"
export * from "./StatisticsLicenseDetails.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsLicenseDetails.vue?vue&type=style&index=0&id=2523a7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523a7d3",
  null
  
)

export default component.exports